module.exports = __webpack_public_path__ + "img/theme-b.5f4ec560.png";